<template>
  <div class="chart-wrapper">
    <div class="gradient-text">
      <span>区块链数字化底座</span>

      <div class="subscribe">
        <div class="subscribe-tit">订阅区块链</div>
        <el-select v-model="value" size="large" clearable placeholder="" @change="handleSelect">
          <el-option
            v-for="(item, i) in options"
            :key="item.ChainId + i"
            :label="item.ChainName"
            :value="item.ChainId"
          >
          </el-option>
        </el-select>
      </div>

      <div class="exit-btn" @click="exitFullscreen"></div>
    </div>

    <div class="node-box">
      <div class="node-type">
        <div class="node-content">
          <div class="node-title">
            <div class="node-title-text">节点类型</div>
            <div class="node-title-img"></div>
          </div>
          <nodeType></nodeType>
        </div>
      </div>
      <div class="black-box">
        <blockData></blockData>
      </div>
      <div class="latest-transactions">
        <div class="transactions-content">
          <div class="transactions-title">
            <div class="transactions-title-text">最新交易</div>
            <div class="transactions-title-img"></div>
          </div>
          <transactionsList></transactionsList>
        </div>
      </div>
    </div>

    <div class="transactions-box">
      <div class="transactions-type-num">
        <div class="transactions-type-content">
          <div class="transactions-type-title">
            <div class="transactions-type-title-text">交易类型请求数</div>
            <div class="transactions-type-title-img"></div>
          </div>
          <txRequest></txRequest>
        </div>
      </div>

      <div class="tx-trend">
        <div class="tx-trend-content">
          <div class="tx-trend-title">
            <div class="tx-type-trend-text">最近24H交易趋势</div>
            <div class="tx-trend-img"></div>
          </div>
          <txTrend></txTrend>
        </div>
      </div>

      <div class="new-block">
        <newBlock></newBlock>
      </div>
    </div>

    <div class="block-details">
      <div class="block-item block-request-num">
        <div class="block-request-content">
          <div class="block-request-title">
            <div class="block-request-title-text">查询类请求数</div>
            <div class="block-request-title-img"></div>
          </div>
          <queryRequest></queryRequest>
        </div>
      </div>
      <div class="block-item block-details-num">
        <div class="block-num-content">
          <div class="block-num-title">
            <div class="block-num-title-text">近7天区块数量</div>
            <div class="block-num-title-img"></div>
          </div>
          <blockNum></blockNum>
        </div>
      </div>
      <div class="block-item block-details-time">
        <div class="block-time-content">
          <div class="block-time-title">
            <div class="block-time-title-text">区块验证时间</div>
            <div class="block-time-title-img"></div>
          </div>
          <blockTime></blockTime>
        </div>
      </div>
      <div class="block-item block-details-size">
        <div class="block-size-content">
          <div class="block-size-title">
            <div class="block-size-title-text">区块大小</div>
            <div class="block-size-title-img"></div>
          </div>
          <blockSize></blockSize>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import nodeType from './components/nodeType' //节点类型
import blockData from './components/blockData' //节点类型

import txRequest from './components/txRequest' //交易类请求数
import txTrend from './components/txTrend' //最近7日交易趋势
import newBlock from './components/newBlock' //最新区块
import transactionsList from './components/transactionsList'
import queryRequest from './components/queryRequest' //查询类请求数
import blockNum from './components/blockNum' //查询类请求数
import blockTime from './components/blockTime' //查询类请求数
import blockSize from './components/blockSize' //查询类请求数

export default {
  name: 'Login',
  components: {
    nodeType,
    blockData,
    transactionsList,
    txRequest,
    newBlock,
    txTrend,
    queryRequest,
    blockNum,
    blockTime,
    blockSize
  },
  data() {
    return {
      value: '',
      options: []
    }
  },
  created() {},
  mounted() {
    // this.enterFullscreen()
    document.getElementById('page-preloading').style.display = 'none'
    this.getOptions()
  },
  methods: {
    handleSelect(id) {
      id && this.$store.commit('updateChainCid', id)
      sessionStorage.setItem('cbaas_chain_id', id)
    },
    getOptions() {
      let param = {
        offset: 0,
        limit: 50
      }
      this.$apis.home.getSubscribeQueryList(param).then(res => {
        if (res.data && res.data.items) {
          //DPOS共识类型的链，不可在大屏图表页选择
          let items = res.data.items.filter(e => {
            return e.Consensus != 'DPOS'
          })

          this.options = items
          if (items.length === 0) {
            this.$store.commit('updateLoading', false)
            this.$message.warning('请订阅区块链！')
          } else {
            let storeId = sessionStorage.getItem('cbaas_chain_id')
            let storeItem = this.options.filter(ele => ele.ChainId === storeId)
            let id = storeItem.length > 0 ? storeId : this.options[0]?.ChainId
            this.value = id
            this.$store.commit('updateChainCid', id)
            sessionStorage.setItem('cbaas_chain_id', id)
          }
        }
      })
    },
    // 进入全屏模式
    enterFullscreen() {
      var elem = document.documentElement
      if (elem.requestFullscreen) {
        elem.requestFullscreen()
      } else if (elem.webkitRequestFullscreen) {
        /* Safari */
        elem.webkitRequestFullscreen()
      } else if (elem.msRequestFullscreen) {
        /* IE11 */
        elem.msRequestFullscreen()
      }
    },
    // 退出全屏模式
    exitFullscreen() {
      // const doc = window.document;

      // if (doc.fullscreenElement) {
      //   doc.exitFullscreen();
      // } else if (doc.webkitFullscreenElement) {
      //   if (doc.webkitExitFullscreen) {
      //     doc.webkitExitFullscreen();
      //   }
      // } else if (doc.mozFullScreenElement) {
      //   if (doc.mozCancelFullScreen) {
      //     doc.mozCancelFullScreen();
      //   }
      // } else if (doc.msFullscreenElement) {
      //   if (doc.msExitFullscreen) {
      //     doc.msExitFullscreen();
      //   }
      // } else {
      //   console.log('Document is not in fullscreen mode.');
      // }

      window.history.back()
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/compatible/index.scss';

.chart-wrapper {
  background: #020f17;
  position: relative;

  .gradient-text {
    background-image: url('../../assets/images/char/head.png');
    background-repeat: no-repeat;
    background-size: cover;
    position: relative;

    .subscribe {
    }

    .exit-btn {
      background-image: url('../../assets/images/char/exit.png');
      background-repeat: no-repeat;
      background-size: cover;
    }
  }

  .gradient-text span {
    background-image: linear-gradient(to bottom, #b2ccfc, #ffffff);
    -webkit-background-clip: text;
    background-clip: text;
    color: transparent;
    font-weight: bold;
    /* 将文字颜色设置为黑色，以便在背景中显示 */
  }

  .node-type {
    background-image: url('../../assets/images/char/node.png');
    background-repeat: no-repeat;
    background-size: 100% 100%;
  }

  .node-title-text {
    background-image: linear-gradient(to bottom, #b2ccfc, #ffffff);
    -webkit-background-clip: text;
    background-clip: text;
    color: transparent;
    font-weight: bold;
    /* 将文字颜色设置为黑色，以便在背景中显示 */
  }

  .node-title-img {
    background-image: url('../../assets/images/char/titleLine.png');
    background-repeat: no-repeat;
    background-size: cover;
    /* 将文字颜色设置为黑色，以便在背景中显示 */
  }

  .black-box {
  }

  .latest-transactions {
    background-image: url('../../assets/images/char/transactionRight.png');
    background-repeat: no-repeat;
    background-size: 100% 100%;

    .transactions-title-img {
      background-image: url('../../assets/images/char/titleLine.png');
      background-repeat: no-repeat;
      background-size: cover;
      /* 将文字颜色设置为黑色，以便在背景中显示 */
    }

    .transactions-title-text {
      background-image: linear-gradient(to bottom, #b2ccfc, #ffffff);
      -webkit-background-clip: text;
      background-clip: text;
      color: transparent;
      font-weight: bold;
      /* 将文字颜色设置为黑色，以便在背景中显示 */
    }
  }

  .transactions-box {
    .transactions-type-num {
      background-image: url('../../assets/images/char/txLeft.png');
      background-repeat: no-repeat;
      background-size: cover;

      .transactions-type-title-text {
        background-image: linear-gradient(to bottom, #b2ccfc, #ffffff);
        -webkit-background-clip: text;
        background-clip: text;
        color: transparent;
        font-weight: bold;
      }

      .transactions-type-title-img {
        background-image: url('../../assets/images/char/titleLine.png');
        background-repeat: no-repeat;
        background-size: cover;
      }
    }
  }

  .tx-trend {
    background-image: url('../../assets/images/char/tx_trend.png');
    background-repeat: no-repeat;
    background-size: cover;

    .tx-type-trend-text {
      @include px2vw(font-size, 18);
      @include px2vw(width, 156);
      font-weight: bold;
      background-image: linear-gradient(to bottom, #b2ccfc, #ffffff);
      -webkit-background-clip: text;
      background-clip: text;
      color: transparent;
      font-weight: bold;
    }

    .tx-trend-img {
      background-image: url('../../assets/images/char/titleLine.png');
      background-repeat: no-repeat;
      background-size: cover;
    }
  }

  .new-block {
    background-image: url('../../assets/images/char/new_block.png');
    background-repeat: no-repeat;
    background-size: 100% 100%;
  }

  .block-details {
    .block-request-num {
      background-image: url('../../assets/images/char/queryRequest.png');
      background-repeat: no-repeat;
      background-size: 100% 100%;

      .block-request-content {
        .block-request-title-text {
          @include px2vw(font-size, 18);
          @include px2vw(width, 156);
          font-weight: bold;
          background-image: linear-gradient(to bottom, #b2ccfc, #ffffff);
          -webkit-background-clip: text;
          background-clip: text;
          color: transparent;
          font-weight: bold;
        }

        .block-request-title-img {
          background-image: url('../../assets/images/char/titleLine.png');
          background-repeat: no-repeat;
          background-size: cover;
        }
      }
    }

    .block-details-num {
      background-image: url('../../assets/images/char/blockNum.png');
      background-repeat: no-repeat;
      background-size: 100% 100%;

      .block-num-content {
        .block-num-title-text {
          @include px2vw(font-size, 18);
          @include px2vw(width, 156);
          font-weight: bold;
          background-image: linear-gradient(to bottom, #b2ccfc, #ffffff);
          -webkit-background-clip: text;
          background-clip: text;
          color: transparent;
          font-weight: bold;
        }

        .block-num-title-img {
          background-image: url('../../assets/images/char/titleLine.png');
          background-repeat: no-repeat;
          background-size: cover;
        }
      }
    }

    .block-details-time {
      background-image: url('../../assets/images/char/blockTime.png');
      background-repeat: no-repeat;
      background-size: 100% 100%;

      .block-time-content {
        .block-time-title-text {
          @include px2vw(font-size, 18);
          @include px2vw(width, 156);
          font-weight: bold;
          background-image: linear-gradient(to bottom, #b2ccfc, #ffffff);
          -webkit-background-clip: text;
          background-clip: text;
          color: transparent;
          font-weight: bold;
        }

        .block-time-title-img {
          background-image: url('../../assets/images/char/titleLine.png');
          background-repeat: no-repeat;
          background-size: cover;
        }
      }
    }

    .block-details-size {
      background-image: url('../../assets/images/char/blockSize.png');
      background-repeat: no-repeat;
      background-size: 100% 100%;

      .block-size-content {
        .block-size-title-text {
          @include px2vw(font-size, 18);
          @include px2vw(width, 156);
          font-weight: bold;
          background-image: linear-gradient(to bottom, #b2ccfc, #ffffff);
          -webkit-background-clip: text;
          background-clip: text;
          color: transparent;
          font-weight: bold;
        }

        .block-size-title-img {
          background-image: url('../../assets/images/char/titleLine.png');
          background-repeat: no-repeat;
          background-size: cover;
        }
      }
    }
  }
}
</style>
